import { Link } from 'react-router-dom';

/** A human sentence and a way out. Never a code, never a stack trace. */
export default function NotFound() {
  return (
    <div className="empty" style={{ minHeight: '70dvh', justifyContent: 'center' }}>
      <div className="mark" aria-hidden="true">♠</div>
      <h4 style={{ margin: 0 }}>There's nothing here</h4>
      <p>That link has gone stale, or it was never quite right. The schedule is the useful page anyway.</p>
      <Link className="btn btn-primary" to="/now">Take me to what's next</Link>
    </div>
  );
}
